import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { CELL_SETS_ERROR, CELL_SETS_CLUSTERING_UPDATING } from 'redux/actionTypes/cellSets';
import getTimeoutForWorkerTask from 'utils/getTimeoutForWorkerTask';
import fetchWork from 'utils/work/fetchWork';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
var runCellSetsClustering = function runCellSetsClustering(experimentId, resolution) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets, error, updatingClustering, loading, _getState, processing, method, body, timeout;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getCellSets = getCellSets()(getState().cellSets), error = _getCellSets.error, updatingClustering = _getCellSets.updatingClustering, loading = _getCellSets.loading;
            _getState = getState(), processing = _getState.experimentSettings.processing;
            method = processing.configureEmbedding.clusteringSettings.method;
            if (!(loading && updatingClustering || error)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", null);
          case 5:
            body = {
              name: 'ClusterCells',
              cellSetName: 'Louvain clusters',
              type: method,
              cellSetKey: 'louvain',
              config: {
                resolution: resolution
              }
            };
            dispatch({
              type: CELL_SETS_CLUSTERING_UPDATING
            });
            timeout = getTimeoutForWorkerTask(getState(), 'ClusterCells');
            _context.prev = 8;
            _context.next = 11;
            return fetchWork(experimentId, body, getState, dispatch, {
              timeout: timeout,
              broadcast: true
            });
          case 11:
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](8);
            dispatch({
              type: CELL_SETS_ERROR,
              payload: {
                experimentId: experimentId,
                error: _context.t0.message
              }
            });
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[8, 13]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default runCellSetsClustering;